var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrap content-wrap--notfall content-wrap--bigger"},[_c('kapp-header',{attrs:{"id":"mainHeader"}}),_vm._v(" "),_vm._l((_vm.content),function(data){return _c('master-block',{key:data.title,attrs:{"data":data}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-89806728","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/KappNotfall.vue
// module id = null
// module chunks = 